$(document).ready(function(){
  $("#searchIconRedireccion").click(function(event){
    event.stopPropagation();
    $(".predictive-search-header").attr("style", "display: flex;");
  });

  $(".search__input").click(function(event){
    event.stopPropagation();
    $(".predictive-search-header").attr("style", "display: flex;");
  })
});

$("#Search").click(function(event){
  event.stopPropagation();
  if($(window).width() <= 768){
     $(".container-options-search").attr("style", "display: flex;"); 
   }else{
     if(!$("#borrarTextoInput").is(":visible")){
       $("#borrarTextoInput").html("Borrar");
       $("#borrarTextoInput").attr("style", "display: block;");
       $(".container-options-search").attr("style", "display: flex; animation: heightAnimation 2s;");  
    }else{
       $(".container-options-search").attr("style", "display: flex; animation: heightAnimation 2s;");  
    }
      
  }
});

$("#Search").keyup(function(event){
   if($(window).width() <= 768){
     if(event.target.value != ""){
       $("#borrarTextoInput").html('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" class="ebx-search-box__cross"><path fill="#3A3A3A" fill-rule="nonzero" d="M20.206 19.5l5.646-5.647a.5.5 0 0 0-.707-.707l-5.646 5.647-5.646-5.647a.5.5 0 0 0-.707.707l5.646 5.647-5.646 5.647a.5.5 0 0 0 .708.707l5.646-5.647 5.646 5.647a.498.498 0 0 0 .708 0 .5.5 0 0 0 0-.707L20.208 19.5h-.002z"></path></svg>')  
     }else{
       $("#borrarTextoInput").html('<img src="https://cdn.shopify.com/s/files/1/2094/8685/files/Busqueda-1.svg?v=1676413387" class="icon-brown" id="icon-brown" alt="Busqueda" width="20px" height="20px" />')
     }
     
   }else{
     if(!$("#borrarTextoInput").is(":visible")){
       $("#borrarTextoInput").html("Borrar");
       $("#borrarTextoInput").attr("style", "display: block;");
     }
      
   }
  
})

$("#borrarTextoInput").click(function(event){
  event.stopPropagation();
  $("#Search").val("");
  if($(window).width() <= 768){
    $("#borrarTextoInput").html('<img src="https://cdn.shopify.com/s/files/1/2094/8685/files/Busqueda-1.svg?v=1676413387" class="icon-brown" id="icon-brown" alt="Busqueda" width="20px" height="20px" />');
  }
})


if(sessionStorage.getItem("_sp") != null && sessionStorage.getItem("_sp") != undefined){
  let arrayJSON2 = JSON.parse(sessionStorage.getItem("_sp"));
  if(arrayJSON2.length > 0){
    $(".ultimas-busquedas").attr("style", "display: flex;");
    $(".ultimas-busquedas ul").attr("style", "overflow-y: scroll; scrollbar-color: rgba(0, 0, 0, .5) rgba(0, 0, 0, 0); scrollbar-width: thin;");
    for (let index = 0; index < arrayJSON2.length; index++) {
      $(".ultimas-busquedas ul").append('<li class="item-options-search"><a href="/search?q='+arrayJSON2[index]+'">'+arrayJSON2[index]+'</a><span>X</span></li>')
    }
  }else{
    $(".ultimas-busquedas").attr("style", "display: none;");
  }
}

$("#Search").change(function(e){
  let arrayWordsSearh = [];
  let value = e.target.value.trim(); 
  
  if(value != ""){
    if(sessionStorage.getItem("_sp") != null && sessionStorage.getItem("_sp") != undefined){
        let arrayJSON = JSON.parse(sessionStorage.getItem("_sp"));
        let resultado = arrayJSON.filter(element => element != e.target.value);
        if(resultado.length > 0){
          for (let index = 0; index < resultado.length; index++) {
            arrayWordsSearh.push(resultado[index])  
          }
        }
    }
    arrayWordsSearh.push(e.target.value);
    sessionStorage.setItem("_sp", JSON.stringify(arrayWordsSearh));
  }

  if(sessionStorage.getItem("_sp") != null && sessionStorage.getItem("_sp") != undefined){
  let arrayJSON2 = JSON.parse(sessionStorage.getItem("_sp"));
  if(arrayJSON2.length > 0){
      $(".ultimas-busquedas ul").empty();
      $(".ultimas-busquedas").attr("style", "display: flex;");
      $(".ultimas-busquedas ul").attr("style", "overflow-y: scroll; scrollbar-color: rgba(0, 0, 0, .5) rgba(0, 0, 0, 0); scrollbar-width: thin;");
      for (let index = 0; index < arrayJSON2.length; index++) {
        $(".ultimas-busquedas ul").append('<li class="item-options-search"><a href="/search?q='+arrayJSON2[index]+'">'+arrayJSON2[index]+'</a><span>X</span></li>')
      }
    }else{
      $(".ultimas-busquedas").attr("style", "display: none;");
    }
  }
})

$(document).on("click", ".item-options-search span", function(event){
  event.stopPropagation();
  $(".container-options-search").attr("style", "display: flex;");  
  if(sessionStorage.getItem("_sp") != null && sessionStorage.getItem("_sp") != undefined){
      let arrayJSON = JSON.parse(sessionStorage.getItem("_sp"));
      let resultado = arrayJSON.filter(element => element != $(this).parent().find("a").text());
      sessionStorage.setItem("_sp", JSON.stringify(resultado));
  }
  
  if(sessionStorage.getItem("_sp") != null && sessionStorage.getItem("_sp") != undefined){
    let arrayJSON2 = JSON.parse(sessionStorage.getItem("_sp"));
    if(arrayJSON2.length > 0){
        $(".ultimas-busquedas ul").empty();
        $(".ultimas-busquedas").attr("style", "display: flex;");
        $(".ultimas-busquedas ul").attr("style", "overflow-y: scroll; scrollbar-color: rgba(0, 0, 0, .5) rgba(0, 0, 0, 0); scrollbar-width: thin;");
        for (let index = 0; index < arrayJSON2.length; index++) {
          $(".ultimas-busquedas ul").append('<li class="item-options-search"><a href="/search?q='+arrayJSON2[index]+'">'+arrayJSON2[index]+'</a><span>X</span></li>')
        }
    }else{
        $(".ultimas-busquedas").attr("style", "display: none;");
    }
  }
})

$("#borrarSessionStorage").click(function(event){
  event.stopPropagation();
  sessionStorage.removeItem("_sp");
  $(".container-options-search").attr("style", "display: flex;");  
  $(".ultimas-busquedas").attr("style", "display: none;");
})

$("html").click(function(){
  $(".container-options-search").attr("style", "display: none;");
});

$(".close-search-predictiva").click(function(event){
   $(".predictive-search-header").attr("style", "display: none;");
})

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,tag,vendor&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        if($(this.predictiveSearchResults).find("#predictive-search-results").find("ul").find("li").length > 0){
          $(".container-options-search").attr("style", "display: none;");
        }
        $(this.predictiveSearchResults).find(".ver-todos-los-productos").find("span").text(this.predictiveSearchResults.dataset.title_todos_productos);
        $(this.predictiveSearchResults).find(".ver-todos-los-productos").find("a").text(this.predictiveSearchResults.dataset.cta_todos_productos);
       

        if($(this.predictiveSearchResults).find('#predictive-search-results').text().includes("No existen productos con esta busqueda") &&
          $(this.predictiveSearchResults).find("#sugerencias").find(".row-sugerencias").eq(1).text().includes("No existen sugerencias de colecciones con esta busqueda!") &&
          $(this.predictiveSearchResults).find("#sugerencias").find(".row-sugerencias").eq(0).text().includes("No existen sugerencias con esta busqueda!")){
           $(this.predictiveSearchResults).find("#sugerencias").find(".row-sugerencias").eq(0).parent().attr("style", "display: none;");
           $(this.predictiveSearchResults).find("#sugerencias").find(".row-sugerencias").eq(1).parent().attr("style", "display: none;");
           $(this.predictiveSearchResults).find('#predictive-search-results').attr("style", "text-align: center;").parent().attr("style", "width: 100%; padding: 10px 30px;");
           $("#containerLoMasBuscado").attr("style", "display: none;");
           $("#containerInteresado").attr("style", "display: flex;");
        }else{
          $("#containerLoMasBuscado").attr("style", "display: flex;");
          $("#containerInteresado").attr("style", "display: none;");
        }
        
        /*if($(resultsMarkup).find('li').length > 3){
          $("#predictive-search-results ul").slick({
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: false,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 4000,
            prevArrow: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 59.414 59.414" style="display: block;" xml:space="preserve" fill="#c2c2c2" width="80px" class="slick-arrow"><polygon points="45.268,1.414 43.854,0 14.146,29.707 43.854,59.414 45.268,58 16.975,29.707 "></polygon><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>',
            nextArrow: '<svg class="right-arrow slick-arrow" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 59.414 59.414" style="display: block;" xml:space="preserve" fill="#c2c2c2" width="80px"><polygon points="15.561,0 14.146,1.414 42.439,29.707 14.146,58 15.561,59.414 45.268,29.707 "></polygon><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>',
            pauseOnHover: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  infinite: true,
                  dots: false,
            	  arrows: true,
                  autoplay: true
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: false,
            	  arrows: false,
                  autoplay: true,
                }
              }
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]
          })
        }else{
          $("#predictive-search-results ul").attr("style", "display: flex;")
        }*/
        
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    this.predictiveSearchResults.style.display = 'flex';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);